(function() {
  function adjustMasonryHeight() {
    const tiles = document.getElementById('resource-tiles');
    if (!tiles) return;
    const tileEls = tiles.querySelectorAll('.tile');
    if (!tileEls.length) return;
    const heights = [0, 0, 0];
    tileEls.forEach((tile, i) => {
      heights[i % 3] += tile.offsetHeight;
    });
    tiles.style.height = Math.max(...heights) + 'px';
  }

  document.addEventListener('turbolinks:load', adjustMasonryHeight);
})();
